/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs */



/**
* | output |
* | --- |
* | "Position Events to the bottom left of the video" |
*
* @param {Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_position_bottom_left = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Position_Bottom_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionner les evenements en bas a gauche de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionieren Sie die Ereignisse unten links im Video.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posiziona gli eventi in basso a sinistra del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разместите события в левом нижнем углу видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Colocar eventos en la parte inferior izquierda del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频左下角的位置事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントをビデオの左下に配置する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो के निचले बाएँ कोने में घटनाओं की स्थिति निर्धारित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicione os eventos na parte inferior esquerda do vídeo.")
	return /** @type {LocalizedString} */ ("Position Events to the bottom left of the video")
});